var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginGoogleLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1627_8680)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0361 5.45655C13.0036 4.4718 11.6257 3.93533 10.2 3.95738C7.59116 3.95738 5.37548 5.71742 4.58546 8.08742C4.16658 9.32938 4.16657 10.6743 4.58546 11.9162H4.58913C5.38281 14.2826 7.59482 16.0426 10.2037 16.0426C11.5504 16.0426 12.7065 15.6982 13.6026 15.0898V15.0873C14.6571 14.3892 15.3773 13.2905 15.6015 12.0485H10.2V8.19772H19.6323C19.7499 8.86647 19.805 9.54992 19.805 10.2297C19.805 13.2712 18.718 15.8427 16.8267 17.5844L16.8287 17.5859C15.1715 19.1145 12.897 20 10.2 20C6.419 20 2.96135 17.8688 1.26375 14.492C-0.154572 11.6664 -0.154568 8.33733 1.26376 5.51169C2.96136 2.1312 6.419 2.50159e-06 10.2 2.50159e-06C12.6839 -0.0293931 15.0833 0.903916 16.8912 2.60151L14.0361 5.45655Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1627_8680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGoogleLight);
export default __webpack_public_path__ + "static/media/login-google-light.806edcfa78fed4eca83e819cf259db92.svg";
export { ForwardRef as ReactComponent };